import React from 'react';
import './ContractsAddPage.scss';
import ContractAddForm from "../../../forms/ContractAddForm/ContractAddForm";

const ContractsAddPage = () => (
  <div className="ContractsAddPage" data-testid="ContractsAddPage">
    <ContractAddForm />
  </div>
);

ContractsAddPage.propTypes = {};

export default ContractsAddPage;
